import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  InputHTMLAttributes,
} from 'react';



import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';

import { Container } from './styles';
import { Error } from '../styles';

import format from '../../../utils/format';
import { useForm } from '../../UIComponents/Form/provider/formProvider';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
 
  setCallback?: Function;

}
const MaskedCurrencyInput: React.FC<Props> = ({
  name,
  icon: Icon,
  setCallback = (string: string) => { },
 

  ...rest
}) => {
  const inputRef = useRef(null);

  const [isFocus, setIsFocus] = useState(false);

  const [value, setValue] = useState(format('0'));

  const handleInputFocus = useCallback(() => {
    setIsFocus(true);
  }, []);



  const applyFilter = (inputValue: string) => {
    setValue(format(inputValue));
  };


  const { registerField } = useForm();
  const setValueData = (content) => {

    setValue(content)
  }

  const getValue = () => {

    return  value.toString().replace(/[^0-9]/g, '') ;
  }

  useEffect(() => {
    registerField(
      name,
      setValueData,
      getValue
    );
  }, [name, value]);

  return (
    <Container isFocused={isFocus}>
      <label>{rest.placeholder}</label>
      {Icon && <Icon />}
      <div className="currencyDiv row-start">
        <label style={{position:'relative'}}>R$ </label>
        <input
          onChange={e => {
            applyFilter(e.target.value);
            setCallback(e.target.value);
          }}
          onFocus={handleInputFocus}

          ref={inputRef}
          value={ format(value)}
          {...rest}
        />
      </div>

    </Container>
  );
};
export default MaskedCurrencyInput;
